// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"95":"f76fa4f6","2238":"fc6ed8ba","9228":"cbfcd693"}[chunkId] + ".chunk.css");